<div class="fixed inset-0 z-50 flex items-center justify-center bg-[#3F44447A] backdrop-blur-sm p-3 antialiased">
  <div class="relative w-full max-w-[380px] rounded-3xl overflow-hidden shadow-2xl"
    style="background: linear-gradient(160deg, #1565C0 0%, #0D47A1 50%, #0A3880 100%);">

    <button type="button" (click)="closeModal.emit()"
      class="absolute top-4 right-4 flex items-center justify-center size-8 rounded-full bg-white/20 hover:bg-white/30 transition-all duration-200 ease-in-out">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2.5" stroke="currentColor"
        class="size-4 text-white">
        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
      </svg>
    </button>

    <div class="p-8 flex flex-col gap-6">
      @if(modalStep() === 1){
      <div class="flex flex-col gap-3">
        <h2 class="text-2xl font-extrabold text-white leading-tight">Plano Otimiza</h2>
        <p class="text-sm text-blue-200 leading-relaxed">
          Para farmácias que querem evoluir a gestão de forma contínua, com previsibilidade e resultados reais.
        </p>
      </div>

      <div class="flex items-baseline gap-2">
        <span class="text-4xl font-extrabold text-white">R$ 399,00</span>
        <span class="text-sm text-blue-300 font-medium">por mês</span>
      </div>

      <hr class="border-white/20" />

      <ul class="flex flex-col gap-3">
        <li class="flex items-start gap-2.5">
          <span class="mt-1.5 size-1.5 rounded-full bg-white flex-shrink-0"></span>
          <span class="text-sm text-blue-100 leading-snug">
            Uso ilimitado de todas as funcionalidades essenciais
          </span>
        </li>
        <li class="flex items-start gap-2.5">
          <span class="mt-1.5 size-1.5 rounded-full bg-white flex-shrink-0"></span>
          <span class="text-sm text-blue-100 leading-snug">
            Ideal para uso diário na operação
          </span>
        </li>
        <li class="flex items-start gap-2.5">
          <span class="mt-1.5 size-1.5 rounded-full bg-white flex-shrink-0"></span>
          <span class="text-sm text-blue-100 leading-snug">
            Contratação mínima de 3 meses
          </span>
        </li>
      </ul>


      } @else if(modalStep() === 2){
      <div class="flex flex-col gap-3">
        <h2 class="text-2xl font-extrabold text-white leading-tight">Quase lá!</h2>
        <p class="text-sm text-blue-200 leading-relaxed">
          Em breve você será redirecionado para a página de pagamento.
        </p>
        <p class="text-sm text-blue-200 leading-relaxed">Status: {{ paymentStatus() === 'active'
          ? 'Aguardando pagamento' : paymentStatus() }}</p>
      </div>
      } @else if(modalStep() === 3) {
      <div class="flex flex-col gap-3 items-center text-center">
        <h2 class="text-2xl font-extrabold text-white leading-tight">Pagamento confirmado!</h2>
        <p class="text-sm text-blue-200 leading-relaxed">
          Recebemos a confirmação de pagamento, agora é só fazer clicar no botão abaixo para fazer o login novamente.
        </p>
      </div>
      }
      @if(modalStep() === 3){
        <button type="button" (click)="finalizePayment()" [disabled]="isLoading()"
          class="w-full py-4 rounded-2xl bg-white text-[#1565C0] font-bold text-base hover:bg-blue-50 transition-all duration-200 ease-in-out shadow-lg disabled:opacity-70 disabled:cursor-not-allowed flex items-center justify-center gap-2">
          Fazer login
        </button>

      } @else {
        <button type="button" (click)="requestPaymentLink()" [disabled]="isLoading()"
          class="w-full py-4 rounded-2xl bg-white text-[#1565C0] font-bold text-base hover:bg-blue-50 transition-all duration-200 ease-in-out shadow-lg disabled:opacity-70 disabled:cursor-not-allowed flex items-center justify-center gap-2">
          @if (isLoading()) {
          <svg class="animate-spin size-5 text-[#1565C0]" xmlns="http://www.w3.org/2000/svg" fill="none"
            viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
          </svg>
          Aguarde...
          } @else {
          Assinar plano
          }
        </button>

      }
    </div>
  </div>
</div>
